import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Inner extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.props.onMounted();
  }
  render() {
    return this.props.children;
  }
}

Inner.propTypes = {
  children: PropTypes.node,
  onMounted: PropTypes.func,
};

Inner.defaultProps = {
  onMounted: () => {},
  children: null,
};


export default Inner;
